import { enableProdMode } from '@angular/core';

import { environment } from './environments/environment';
import { AbsenceCostComponent } from './components/absence-cost/absence-cost.component';
import { AbsenceCostWrapper } from './components/absence-cost-wrapper/absence-cost-wrapper.component';
import { provideAbsenceCostCalculator } from '@helsana/absence-cost-calculator';
import { provideWebComponent } from './utils/webcomponents';

/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 ~ Copyright 2020 Adobe Systems Incorporated
 ~
 ~ Licensed under the Apache License, Version 2.0 (the "License");
 ~ you may not use this file except in compliance with the License.
 ~ You may obtain a copy of the License at
 ~
 ~     http://www.apache.org/licenses/LICENSE-2.0
 ~
 ~ Unless required by applicable law or agreed to in writing, software
 ~ distributed under the License is distributed on an "AS IS" BASIS,
 ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 ~ See the License for the specific language governing permissions and
 ~ limitations under the License.
 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

if (environment.production) {
  enableProdMode();
}

provideWebComponent(
  'aem-absence-cost-app',
  'absence-cost',
  AbsenceCostComponent,
  AbsenceCostWrapper,
  provideAbsenceCostCalculator
);
